import { createContext, useContext } from 'react';

/**
 * True inside a `<ProfileCard>` whose body draws no padding — the default.
 *
 * Content that draws its own border reads this and drops it, because the card has already
 * drawn one. Without it the two sit on top of each other: a doubled line all the way round,
 * and the card's rounded corners squared off by the box inside them.
 *
 * The same shape, for the same reason, as `IndexTableSurfaceContext` and `ListSurfaceContext`
 * — a component adapting to the surface it was rendered on rather than every call site
 * remembering to tell it. `<AvatarCell>` dropping its avatar on the list surface is the
 * closest precedent: two components drawing one thing, resolved where they meet.
 */
export const ProfileCardSurfaceContext = createContext(false);

/** True when the surrounding `<ProfileCard>` expects its content to supply the outer edge. */
export function useFillsProfileCard(): boolean {
  return useContext(ProfileCardSurfaceContext);
}
